(function () {
  var api = window.NCReviewsCarousel || {};
  var AUTO_SCROLL_DELAY = 3200;
  var RESUME_DELAY = 4000;
  var DRAG_THRESHOLD = 18;

  function clearTimer(timerId) {
    if (timerId) {
      window.clearTimeout(timerId);
    }
  }

  function clearIntervalTimer(timerId) {
    if (timerId) {
      window.clearInterval(timerId);
    }
  }

  function getCardPositions(scroller) {
    return Array.prototype.map.call(scroller.children, function (child) {
      return child.offsetLeft - scroller.offsetLeft;
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.ncReviewsCarouselInitialized === "true") return;

    var scroller = root.querySelector("[data-nc-reviews-carousel-scroller]");
    if (!scroller) return;

    var itemCount = parseInt(root.getAttribute("data-nc-reviews-carousel-count") || "0", 10);
    if (!itemCount) return;

    var shouldLoop = itemCount > 1;
    var loopStartIndex = shouldLoop ? itemCount : 0;
    var prevButton = root.querySelector("[data-nc-reviews-carousel-prev]");
    var nextButton = root.querySelector("[data-nc-reviews-carousel-next]");

    var state = {
      currentIndex: loopStartIndex,
      autoScrollTimer: null,
      resumeTimer: null,
      scrollSyncTimer: null,
      programmaticScrollTimer: null,
      loopResetTimer: null,
      isProgrammaticScroll: false,
      drag: {
        isDragging: false,
        pointerId: -1,
        startX: 0,
        startScrollLeft: 0
      },
      handlers: {}
    };

    function getNearestIndex() {
      var positions = getCardPositions(scroller);
      var nearestIndex = 0;
      var nearestDistance;

      if (!positions.length) return loopStartIndex;

      nearestDistance = Math.abs(scroller.scrollLeft - positions[0]);

      positions.forEach(function (position, index) {
        var distance = Math.abs(scroller.scrollLeft - position);

        if (distance < nearestDistance) {
          nearestIndex = index;
          nearestDistance = distance;
        }
      });

      return nearestIndex;
    }

    function scrollToIndex(index, behavior) {
      var positions = getCardPositions(scroller);
      var nextIndex;

      if (!positions.length) return;

      if (shouldLoop) {
        nextIndex = Math.max(0, Math.min(index, positions.length - 1));
      } else {
        nextIndex = (index + positions.length) % positions.length;
      }

      state.currentIndex = nextIndex;
      state.isProgrammaticScroll = true;
      clearTimer(state.programmaticScrollTimer);

      scroller.scrollTo({
        left: positions[nextIndex],
        behavior: behavior || "smooth"
      });

      state.programmaticScrollTimer = window.setTimeout(function () {
        state.isProgrammaticScroll = false;
      }, behavior === "auto" ? 80 : 680);
    }

    function resetLoopPosition() {
      var currentIndex;
      var resetIndex;

      if (!shouldLoop) return;

      currentIndex = getNearestIndex();
      resetIndex = currentIndex;

      if (currentIndex >= itemCount * 2) {
        resetIndex = currentIndex - itemCount;
      } else if (currentIndex < itemCount) {
        resetIndex = currentIndex + itemCount;
      }

      if (resetIndex !== currentIndex) {
        scrollToIndex(resetIndex, "auto");
      } else {
        state.currentIndex = currentIndex;
      }
    }

    function scheduleLoopReset() {
      clearTimer(state.loopResetTimer);
      state.loopResetTimer = window.setTimeout(resetLoopPosition, 720);
    }

    function stopAutoScroll() {
      clearIntervalTimer(state.autoScrollTimer);
      state.autoScrollTimer = null;
    }

    function startAutoScroll() {
      stopAutoScroll();

      if (!shouldLoop) return;

      state.autoScrollTimer = window.setInterval(function () {
        scrollToIndex(state.currentIndex + 1);
        scheduleLoopReset();
      }, AUTO_SCROLL_DELAY);
    }

    function noteInteraction() {
      stopAutoScroll();
      clearTimer(state.resumeTimer);

      state.resumeTimer = window.setTimeout(function () {
        state.currentIndex = getNearestIndex();
        resetLoopPosition();
        startAutoScroll();
      }, RESUME_DELAY);
    }

    function scrollReviews(direction) {
      noteInteraction();
      state.currentIndex = getNearestIndex();
      scrollToIndex(state.currentIndex + (direction === "next" ? 1 : -1));
      scheduleLoopReset();
    }

    state.handlers.prevClick = function () {
      scrollReviews("prev");
    };

    state.handlers.nextClick = function () {
      scrollReviews("next");
    };

    state.handlers.pointerDown = function (event) {
      if (event.pointerType !== "mouse") return;

      noteInteraction();
      state.drag = {
        isDragging: true,
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: scroller.scrollLeft
      };

      if (scroller.setPointerCapture) {
        scroller.setPointerCapture(event.pointerId);
      }

      scroller.classList.add("is-dragging");
    };

    state.handlers.pointerMove = function (event) {
      if (!state.drag.isDragging || state.drag.pointerId !== event.pointerId) return;

      event.preventDefault();
      scroller.scrollLeft = state.drag.startScrollLeft - (event.clientX - state.drag.startX);
    };

    state.handlers.pointerFinish = function (event) {
      var draggedDistance;

      if (!state.drag.isDragging || state.drag.pointerId !== event.pointerId) return;

      draggedDistance = Math.abs(scroller.scrollLeft - state.drag.startScrollLeft);
      state.drag = {
        isDragging: false,
        pointerId: -1,
        startX: 0,
        startScrollLeft: 0
      };

      scroller.classList.remove("is-dragging");

      if (scroller.hasPointerCapture && scroller.hasPointerCapture(event.pointerId)) {
        scroller.releasePointerCapture(event.pointerId);
      }

      if (draggedDistance >= DRAG_THRESHOLD) {
        scrollToIndex(getNearestIndex());
        scheduleLoopReset();
      }
    };

    state.handlers.scroll = function () {
      if (!state.isProgrammaticScroll) {
        noteInteraction();
      }

      clearTimer(state.scrollSyncTimer);
      state.scrollSyncTimer = window.setTimeout(function () {
        state.currentIndex = getNearestIndex();
      }, 120);
    };

    if (prevButton) prevButton.addEventListener("click", state.handlers.prevClick);
    if (nextButton) nextButton.addEventListener("click", state.handlers.nextClick);
    scroller.addEventListener("pointerdown", state.handlers.pointerDown);
    scroller.addEventListener("pointermove", state.handlers.pointerMove);
    scroller.addEventListener("pointerup", state.handlers.pointerFinish);
    scroller.addEventListener("pointercancel", state.handlers.pointerFinish);
    scroller.addEventListener("scroll", state.handlers.scroll, { passive: true });

    root.dataset.ncReviewsCarouselInitialized = "true";
    root.ncReviewsCarouselState = state;

    window.setTimeout(function () {
      scrollToIndex(loopStartIndex, "auto");
    }, 0);
    startAutoScroll();
  }

  function resetRoot(root) {
    var state;
    var scroller;
    var prevButton;
    var nextButton;

    if (!root || !root.ncReviewsCarouselState) return;

    state = root.ncReviewsCarouselState;
    scroller = root.querySelector("[data-nc-reviews-carousel-scroller]");
    prevButton = root.querySelector("[data-nc-reviews-carousel-prev]");
    nextButton = root.querySelector("[data-nc-reviews-carousel-next]");

    clearIntervalTimer(state.autoScrollTimer);
    clearTimer(state.resumeTimer);
    clearTimer(state.scrollSyncTimer);
    clearTimer(state.programmaticScrollTimer);
    clearTimer(state.loopResetTimer);

    if (prevButton) prevButton.removeEventListener("click", state.handlers.prevClick);
    if (nextButton) nextButton.removeEventListener("click", state.handlers.nextClick);

    if (scroller) {
      scroller.removeEventListener("pointerdown", state.handlers.pointerDown);
      scroller.removeEventListener("pointermove", state.handlers.pointerMove);
      scroller.removeEventListener("pointerup", state.handlers.pointerFinish);
      scroller.removeEventListener("pointercancel", state.handlers.pointerFinish);
      scroller.removeEventListener("scroll", state.handlers.scroll);
      scroller.classList.remove("is-dragging");
    }

    delete root.ncReviewsCarouselState;
    delete root.dataset.ncReviewsCarouselInitialized;
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-reviews-carousel]")
      : [];

    if (scope.matches && scope.matches("[data-nc-reviews-carousel]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-reviews-carousel]")
      : [];

    if (scope.matches && scope.matches("[data-nc-reviews-carousel]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCReviewsCarousel = api;

  if (!window.__ncReviewsCarouselEventsBound) {
    window.__ncReviewsCarouselEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCReviewsCarousel.initAll(document);
    });

    document.addEventListener("shopify:section:load", function () {
      window.NCReviewsCarousel.resetAll(document);
      window.NCReviewsCarousel.initAll(document);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCReviewsCarousel.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCReviewsCarousel.initAll(document);
  }
})();
